import Vue from 'vue'
import { ToastPlugin, ModalPlugin } from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'
import VueSweetalert2 from 'vue-sweetalert2';
import i18n from '@/libs/i18n'
import router from './router'
import store from './store'
import CKEditor from '@ckeditor/ckeditor5-vue2'
import App from './App.vue'
// Global Components
import './global-components'
// 3rd party plugins
import '@axios'
import '@/libs/acl'
import '@/libs/portal-vue'
import '@/libs/clipboard'
import '@/libs/toastification'
import '@/libs/sweet-alerts'
import '@/libs/vue-select'
import '@/libs/tour'
import 'sweetalert2/dist/sweetalert2.min.css';
// Axios Mock Adapter
import '@/@fake-db/db'
import AudioVisual from 'vue-audio-visual'
import Dialog from 'vue-dialog-loading';
import { $appConfig } from "../appConfig";

// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)
Vue.use(AudioVisual)
Vue.use(CKEditor)
Vue.use(Dialog)
Vue.use(VueSweetalert2);
// Composition API
Vue.use(VueCompositionAPI)
// Feather font icon - For form-wizard
// * Shall remove it if not using font-icons of feather-icons - For form-wizard
require('@core/assets/fonts/feather/iconfont.css') // For form-wizard
// import core styles
require('@core/scss/core.scss')
// import assets styles
require('@/assets/scss/style.scss')

Vue.config.productionTip = false
new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')

document.querySelector('title').textContent = 'پنل مدیریت ' + $appConfig.endpoint.title;

import VuePersianDatetimePicker from 'vue-persian-datetime-picker';
Vue.use(VuePersianDatetimePicker, {
  name: 'custom-date-picker',
  props: {
    format: 'YYYY-MM-DD HH:mm',
    displayFormat: 'jYYYY-jMM-jDD HH:mm',
    editable: false,
    inputClass: 'form-control my-custom-class-name',
    placeholder: 'لطفا تاریخ را وارد کنید',
    altFormat: 'YYYY-MM-DD HH:mm',
    color: '#00acc1',
    autoSubmit: true,
    //...
    //... And whatever you want to set as default.
    //...
  }
});
